module.exports = __webpack_public_path__ + "img/monitoring.dd870fae.webp";